import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {isNil} from 'lodash';
import {Portal} from 'react-portal';

module.exports = createClass({
  propTypes: {
    header: PropTypes.any,
    content: PropTypes.any,
    footer: PropTypes.any,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    onClose: PropTypes.func,
    className: PropTypes.string,
    dismissable: PropTypes.bool,
    customContainerStyle: PropTypes.object,
    closeIconClassName: PropTypes.string,
    isOpen: PropTypes.bool
  },

  getDefaultProps() {
    return {dismissable: true};
  },

  getInitialState() {
    const {isOpen} = this.props;

    return {
      showDialog: isNil(isOpen) ? true : isOpen
    };
  },

  componentWillReceiveProps(nextProps) {
    if (!isNil(nextProps.isOpen)) {
      this.setState({showDialog: nextProps.isOpen});
    }
  },

  componentWillUnmount() {
    clearTimeout(this.leaving);
  },

  hide() {
    this.setState({
      showDialog: false
    });
    document.body.style.overflow = '';
    if (this.props.onClose) {
      this.leaving = window.setTimeout(this.props.onClose, 305);
    }
  },

  preventDefault(event) {
    event.stopPropagation();
  },

  render() {
    const {showDialog} = this.state;
    const {
      size,
      header,
      content,
      footer,
      className,
      onClose,
      dismissable,
      customContainerStyle,
      closeIconClassName
    } = this.props;

    let classes = 'vf-dialog';

    if (className) classes += ` ${className}`;
    if (size) classes += ` vf-dialog-${size}`;

    return (
      <Portal>
        <ReactCSSTransitionGroup
          transitionName='vf-animation-dialog'
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
          transitionAppear
          transitionAppearTimeout={500}
        >
          {
            showDialog && (
              <div
                className={classes}
                onClick={() => dismissable && this.hide()}
                key='dialog'
              >
                <div
                  className='vf-dialog-container'
                  data-uitest='dialog'
                  onClick={this.preventDefault}
                  ref='dialogContainer'
                  style={customContainerStyle}
                >
                  {
                    header && (
                      <div className='vf-dialog-header vf-clearfix' style={{minHeight: 83}}>
                        <div className='vf-dialog-header-content'>
                          {header}
                        </div>
                        {
                          onClose && (
                            <div
                              className={`icon-close vf-close-button vf-clickable ${closeIconClassName}`}
                              onClick={this.hide}
                            />
                          )
                        }
                      </div>
                    )
                }
                  <div className='vf-dialog-body' ref='dialogBody' style={{height: 'calc(100% - 83px)'}}>
                    <div className='vf-dialog-content vf-clearfix height100'>
                      {content}
                    </div>
                    {
                      footer && (
                        <div className='vf-dialog-footer vf-clearfix'>
                          {this.props.footer}
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            )
        }
        </ReactCSSTransitionGroup>
      </Portal>
    );
  }
});
